import { cdnPublicFolderUrl } from "@/constants"
import { socials } from "@/constants/social"
import { googleAnalytics } from "@/lib/gtag"
import Link from "next/link"
import { InstagramIcon, YoutubeIcon, LinkedInIcon, FacebookIcon, TwitterIcon, RedditIcon } from "../Landing/Home/icons"

const Footer = () => {
  const handleGaSocial = (platform: string, url: string) => {
    googleAnalytics.event({
      action: "click",
      category: "footer_alpha",
      label: "social_media",
      params: {
        platform,
        url,
      },
    })
  }

  const handleGa = (label: string) => {
    googleAnalytics.event({
      action: "click",
      category: "footer_alpha",
      label,
    })
  }

  return (
    <div className="p-4 lg:p-8 flex items-start justify-center">
      <div className="flex flex-col items-center lg:flex-row w-full max-w-[78rem] 4xl:max-w-[86rem] lg:p-4">
        <div className="max-w-[12rem] w-full">
          <img src={`${cdnPublicFolderUrl}/logo.png`} alt="Ather Logo" width={276 * 1.5} height={74 * 1.5} />
        </div>
        <div className="lg:ml-20">
          <div className="border-b border-[#4B4B4B] pb-4 mb-4 flex flex-col lg:flex-row items-center lg:items-end">
            <p className="text-atherGray-500 text-sm my-4 lg:my-0 flex-1">
              GAIA is a multiplayer SaaS platform designed to revolutionize generative AI production management. GAIA
              enables effortless collaboration of the entire process of creation, storage, organization and tracking.
            </p>
            <div className="flex items-center space-x-3 lg:ml-6">
              {socials.map(i => (
                <Link
                  key={i.name}
                  title={i.name}
                  onClick={() => handleGaSocial(i.name, i.url)}
                  href={i.url}
                  target="_blank"
                >
                  {i.name === "facebook" ? (
                    <FacebookIcon className="text-black" />
                  ) : i.name === "instagram" ? (
                    <InstagramIcon className="text-black" />
                  ) : i.name === "youtube" ? (
                    <YoutubeIcon className="text-black" />
                  ) : i.name === "twitter" ? (
                    <TwitterIcon className="text-black" />
                  ) : i.name === "reddit" ? (
                    <RedditIcon className="text-black" />
                  ) : i.name === "linkedin" ? (
                    <LinkedInIcon className="text-black" />
                  ) : null}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between">
            <div className="flex items-center space-x-1  justify-center w-full lg:w-auto lg:justify-end mb-2 lg:mb-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                <path
                  d="M8.5 1.40283C7.08154 1.40283 5.69493 1.82346 4.51552 2.61151C3.33611 3.39957 2.41688 4.51966 1.87405 5.83015C1.33123 7.14064 1.18921 8.58266 1.46593 9.97387C1.74266 11.3651 2.42572 12.643 3.42872 13.646C4.43173 14.649 5.70963 15.332 7.10084 15.6088C8.49205 15.8855 9.93407 15.7435 11.2446 15.2007C12.555 14.6578 13.6751 13.7386 14.4632 12.5592C15.2513 11.3798 15.6719 9.99317 15.6719 8.57471C15.6698 6.67325 14.9135 4.85029 13.569 3.50575C12.2244 2.16122 10.4015 1.40494 8.5 1.40283ZM8.5 14.1528C7.39675 14.1528 6.31828 13.8257 5.40096 13.2127C4.48364 12.5998 3.76868 11.7286 3.34649 10.7094C2.92429 9.69009 2.81383 8.56852 3.02906 7.48647C3.24429 6.40442 3.77556 5.41049 4.55567 4.63038C5.33579 3.85026 6.32971 3.319 7.41176 3.10376C8.49381 2.88853 9.61539 2.999 10.6347 3.42119C11.6539 3.84339 12.5251 4.55835 13.138 5.47567C13.751 6.39298 14.0781 7.47146 14.0781 8.57471C14.0765 10.0536 13.4883 11.4715 12.4426 12.5173C11.3968 13.563 9.97893 14.1512 8.5 14.1528ZM11.2618 10.6472C10.8268 11.2268 10.2205 11.6548 9.5288 11.8707C8.83706 12.0866 8.09494 12.0794 7.40752 11.8501C6.7201 11.6208 6.12224 11.1811 5.69858 10.5932C5.27493 10.0053 5.04696 9.29902 5.04696 8.57437C5.04696 7.84973 5.27493 7.14345 5.69858 6.55555C6.12224 5.96765 6.7201 5.52793 7.40752 5.29865C8.09494 5.06937 8.83706 5.06216 9.5288 5.27804C10.2205 5.49392 10.8268 5.92195 11.2618 6.5015C11.327 6.58495 11.3749 6.68054 11.4027 6.7827C11.4304 6.88486 11.4376 6.99153 11.4237 7.09648C11.4098 7.20143 11.3751 7.30256 11.3217 7.39397C11.2683 7.48537 11.1972 7.56522 11.1126 7.62884C11.028 7.69246 10.9315 7.73858 10.8289 7.76451C10.7262 7.79043 10.6195 7.79565 10.5148 7.77984C10.4101 7.76404 10.3096 7.72753 10.2192 7.67246C10.1288 7.61739 10.0502 7.54485 9.98817 7.45908C9.75402 7.14688 9.42757 6.91627 9.05507 6.79991C8.68257 6.68355 8.2829 6.68734 7.91268 6.81075C7.54246 6.93416 7.22045 7.17092 6.99226 7.48751C6.76408 7.8041 6.64129 8.18446 6.64129 8.57471C6.64129 8.96496 6.76408 9.34531 6.99226 9.6619C7.22045 9.97849 7.54246 10.2153 7.91268 10.3387C8.2829 10.4621 8.68257 10.4659 9.05507 10.3495C9.42757 10.2331 9.75402 10.0025 9.98817 9.69033C10.0497 9.60331 10.1281 9.52951 10.2186 9.47331C10.3092 9.41711 10.4101 9.37965 10.5154 9.36315C10.6207 9.34664 10.7282 9.35142 10.8317 9.37722C10.9351 9.40301 11.0323 9.44928 11.1175 9.51331C11.2027 9.57733 11.2742 9.65779 11.3277 9.74993C11.3813 9.84208 11.4158 9.94403 11.4293 10.0498C11.4428 10.1555 11.4349 10.2628 11.4061 10.3655C11.3774 10.4681 11.3283 10.5639 11.2618 10.6472Z"
                  fill="white"
                />
              </svg>
              <p className="text-xs md:text-sm">Copyright © 2023 VIXION Company Limited. All rights reserved</p>
            </div>
            <div className="space-x-4 flex justify-center w-full lg:w-auto lg:justify-end items-center">
              <Link
                onClick={() => handleGa("terms_of_service")}
                className="underline font-normal text-sm"
                href={"/terms-of-service"}
                target="_blank"
              >
                Terms Of Service
              </Link>
              <div className="h-full w-[1px] bg-[#4B4B4B]" />
              <Link
                onClick={() => handleGa("privacy_policy")}
                className="underline font-normal text-sm"
                href={"/privacy-policy"}
                target="_blank"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
